export default {
  notFound: {
    message: '"Да — был ли мальчик-то, может, мальчика-то и не было?"<br/>Максим Горький',
    code: 404
  },
  wrongToken: {
    message: 'Ссылка на подписание заявки устарела',
    code: 401
  }
}
